if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();
        this.querySelectorAll('[data-media-previous], [data-media-next]').forEach((button) => {
          button.addEventListener('pointerup', (event) => event.stopPropagation());
          button.addEventListener('click', (event) => {
            event.preventDefault();
            event.stopPropagation();
            this.showAdjacentMedia(button.hasAttribute('data-media-previous') ? -1 : 1);
          });
        });
        this.addEventListener('keydown', this.onKeyDown.bind(this));
      }

      hide() {
        super.hide();
      }

      show(opener) {
        super.show(opener);
        this.showActiveMedia();
      }

      showActiveMedia() {
        const gallery = this.openedBy.closest('media-gallery');
        this.gallery = gallery;
        const galleryMediaId = gallery?.querySelector('.product__media-item.is-active')?.dataset.mediaId;
        const mediaId = galleryMediaId?.split('-').pop() || this.openedBy.getAttribute('data-media-id');
        this.setActiveMedia(mediaId);
      }

      setActiveMedia(mediaId) {
        const media = this.mediaItems;
        const activeMedia = media.find((item) => item.dataset.mediaId === mediaId) || media[0];
        if (!activeMedia) return;

        media.forEach((element) => element.classList.toggle('active', element === activeMedia));
        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;

        if (
          activeMedia.nodeName == 'DEFERRED-MEDIA' &&
          activeMediaContent &&
          activeMediaContent.querySelector('.js-youtube')
        )
          activeMedia.loadContent();

        const galleryItem = this.gallery?.querySelector(
          `.product__media-item[data-media-id$="-${activeMedia.dataset.mediaId}"]`
        );
        if (galleryItem) this.gallery.setActiveMedia(galleryItem.dataset.mediaId, false);
      }

      showAdjacentMedia(direction) {
        const media = this.mediaItems;
        const currentIndex = media.findIndex((item) => item.classList.contains('active'));
        const nextIndex = (currentIndex + direction + media.length) % media.length;
        this.setActiveMedia(media[nextIndex]?.dataset.mediaId);
      }

      onKeyDown(event) {
        if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') {
          event.preventDefault();
          this.showAdjacentMedia(event.key === 'ArrowLeft' ? -1 : 1);
        }
      }

      get mediaItems() {
        return Array.from(this.querySelector('.product-media-modal__content')?.children || []).filter(
          (item, index) =>
            item.hasAttribute('data-media-id') &&
            (!item.classList.contains('product__media-item--variant') || index === 0)
        );
      }
    }
  );
}
